// import event Bus
import maEventBus from '@/components/eventbus/index.js'

/**
 * @module
 * @name Input
 * @description Input wrapper for all inputs types. This component should be
 *              extended.
 */
export default {
  name: 'Input',
  /**
   * @property {String} name Input name attribute
   * @property {String} type text, select,... used for assign css class to input
   *                         parent element. See src/input/modules
   * @property {Number} col Number of cols input fits.
   * @property {String} literal Text to be shown in label element.
   * @property {String} agentLiteral Text to be shown in label element, if it's
   *                                 different than property literal.
   * @property {String|Number} value There's a two way binding
   * @property {Boolean} disabled Means if input state is disabled. This property
   *                              implies disable attribute (and his
   *                              correspondant style) or just css disabled class.
   * @property {Boolean} hidden If true, this input won't be displayed.
   * @property {String} autocomplete Input attribute
   */
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    col: {
      type: Number | String,
      required: true
    },
    literal: {
      type: String,
      required: true
    },
    agentLiteral: {
      type: String,
      required: false
    },
    value: {
      type: String | Number,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    hidden: {
      type: Boolean,
      required: false
    },
    autocomplete: {
      type: String,
      required: false
    }
  },
  /**
   * @property {String} inputType Returns and the type of component to be imported
   *                              from ./modules. I.e. it outputs 'maInputText'...
   * @property {String} inputClasses Returns input classes depending in other
   *                                 params/props of the component.
   */
  computed: {
    inputType () {
      return 'maInput' + this.capitalize(this.type)
    },
    inputClasses () {
      return (
        [
          `input--visible-${!this.hidden} `,
          `input--${this.type} `,
          `grid__cell-md-${this.col || '1'}`
        ].join(' ')
      )
    }
  },
  /**
   * @function
   * @name mounted
   * @description First, call to extended component setDefaultValue fn. For
   *              example, used for a select component.
   *              Then, attach focus handler for all input elements and emit them
   *              to outer component.
   */
  mounted: function () {
    if (this.setDefaultValue) {
      this.setDefaultValue()
    }
    this.$el.querySelectorAll('input').forEach((el) => {
      el.addEventListener('focus', () => {
        maEventBus.$emit('inputWarranty:focus', this.value)
      })
    })
  }
}
